<h1 *ngIf="!vm">Loading...</h1>
<div class="container" *ngIf="vm">
  <div class="back-item">
    &larr; <a [routerLink]="'/user-branding'" class="row-header"> Back to Dashboard</a>
  </div>
  <div class="header flex row">
    <h2 class="flex column">Edit: {{vm.domainNameAsUid}}</h2>
    <div class="actions flex row align-items-center">
      <ichannel-button
        [callback]="onCancelClicked.bind(this)"
        [label]="'CANCEL'"
      ></ichannel-button>
      <ichannel-button
        [callback]="onSaveClicked.bind(this)"
        [label]="'SAVE'"
        [theme]="'DARK'"
      ></ichannel-button>
    </div>
  </div>

  <table class="edit-table">
    <tr>
      <td colspan="2"><h3>Login Page</h3></td>

    </tr>
    <tr>
      <td class="row-head">Header Text:</td>
      <td>
        <evrideo-simple-text-input
          [(value)]="vm.login.headerText"
          [disabled]="false"
          [overrideStyle]="{
              'background-color':'transparent',
              'border-color':
                vm.login.headerText && vm.login.headerText.length > 0 ? '#e1e6eb' : 'red'
            }"
          [placeholder]="'Enter Header Text'"
        ></evrideo-simple-text-input>
      </td>
    </tr>
    <tr>
      <td class="row-head">Window Title Text:</td>
      <td>
        <evrideo-simple-text-input
          [(value)]="vm.login.windowTitle"
          [disabled]="false"
          [overrideStyle]="{
              'background-color':'transparent',
              'border-color':
                vm.login.windowTitle && vm.login.windowTitle.length > 0 ? '#e1e6eb' : 'red'
            }"
          [placeholder]="'Enter Window Title Text'"
        ></evrideo-simple-text-input>
      </td>
    </tr>

    <tr>
      <td class="row-head">Favicon Image:</td>
      <td>
        <icn-drag-public-media
          [media]="vm.login.faviconUrl"
          (mediaChange)="vm.login.faviconUrl = $event.isVideo? vm.login.faviconUrl: $event.url"
        ></icn-drag-public-media>
      </td>
    </tr>

    <tr>
      <td class="row-head">Header Image:</td>
      <td>
        <icn-drag-public-media
          [media]="vm.login.headerImageUrl"
          (mediaChange)="vm.login.headerImageUrl = $event.isVideo? vm.login.headerImageUrl: $event.url"
        ></icn-drag-public-media>
      </td>
    </tr>

    <tr>
      <td colspan="2"></td>

    </tr>

    <tr>
      <td colspan="2"></td>

    </tr>

    <tr>
      <td colspan="2"><h3>Backoffice</h3></td>

    </tr>
    <tr>
      <td class="row-head">Header Text:</td>
      <td>
        <evrideo-simple-text-input
          [(value)]="vm.backoffice.headerText"
          [disabled]="false"
          [overrideStyle]="{
              'background-color':'transparent',
              'border-color':
                vm.backoffice.headerText && vm.backoffice.headerText.length > 0 ? '#e1e6eb' : 'red'
            }"
          [placeholder]="'Enter Header Text'"
        ></evrideo-simple-text-input>
      </td>
    </tr>
    <tr>
      <td class="row-head">Tab Title Prefix:</td>
      <td>
        <evrideo-simple-text-input
          [(value)]="vm.backoffice.tabTitlePrefix"
          [disabled]="false"
          [overrideStyle]="{
              'background-color':'transparent',
              'border-color':
                vm.backoffice.tabTitlePrefix && vm.backoffice.tabTitlePrefix.length > 0 ? '#e1e6eb' : 'red'
            }"
          [placeholder]="'Enter Tab Title Prefix'"
        ></evrideo-simple-text-input>
      </td>
    </tr>

    <tr>
      <td class="row-head">Tab Window Title:</td>
      <td>
        <evrideo-simple-text-input
          [(value)]="vm.backoffice.windowTitle"
          [disabled]="false"
          [overrideStyle]="{
              'background-color':'transparent',
              'border-color':
                vm.backoffice.windowTitle && vm.backoffice.windowTitle.length > 0 ? '#e1e6eb' : 'red'
            }"
          [placeholder]="'Enter Tab Window Title'"
        ></evrideo-simple-text-input>
      </td>
    </tr>

    <tr>
      <td class="row-head">Small Browser Image:</td>
      <td>
        <icn-drag-public-media
          [media]="vm.backoffice.browserTooSmallImageUrl"
          (mediaChange)="vm.backoffice.browserTooSmallImageUrl = $event.isVideo? vm.backoffice.browserTooSmallImageUrl: $event.url"
        ></icn-drag-public-media>
      </td>
    </tr>

    <tr>
      <td class="row-head">Favicon Image:</td>
      <td>
        <icn-drag-public-media
          [media]="vm.backoffice.faviconUrl"
          (mediaChange)="vm.backoffice.faviconUrl = $event.isVideo? vm.backoffice.faviconUrl: $event.url"
        ></icn-drag-public-media>
      </td>
    </tr>
    <tr>
      <td class="row-head">Loading Image:</td>
      <td>
        <icn-drag-public-media
          [media]="vm.backoffice.loadingImageUrl"
          (mediaChange)="vm.backoffice.loadingImageUrl = $event.isVideo? vm.backoffice.loadingImageUrl: $event.url"
        ></icn-drag-public-media>
      </td>
    </tr>
    <tr>
      <td class="row-head">Side Image:</td>
      <td>
        <icn-drag-public-media
          [media]="vm.backoffice.sideImageUrl"
          (mediaChange)="vm.backoffice.sideImageUrl = $event.isVideo? vm.backoffice.sideImageUrl: $event.url"
        ></icn-drag-public-media>
      </td>
    </tr>
  </table>
</div>
